/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Response containing security level value information
 * @export
 * @interface SecurityLevelValueResponse
 */
export interface SecurityLevelValueResponse {
    /**
     * 
     * @type {string}
     * @memberof SecurityLevelValueResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SecurityLevelValueResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SecurityLevelValueResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SecurityLevelValueResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * The security level value
     * @type {number}
     * @memberof SecurityLevelValueResponse
     */
    levelValue?: number;
    /**
     * Type of level (min or max)
     * @type {string}
     * @memberof SecurityLevelValueResponse
     */
    levelType?: string;
}

/**
 * Check if a given object implements the SecurityLevelValueResponse interface.
 */
export function instanceOfSecurityLevelValueResponse(value: object): value is SecurityLevelValueResponse {
    return true;
}

export function SecurityLevelValueResponseFromJSON(json: any): SecurityLevelValueResponse {
    return SecurityLevelValueResponseFromJSONTyped(json, false);
}

export function SecurityLevelValueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityLevelValueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'levelValue': json['levelValue'] == null ? undefined : json['levelValue'],
        'levelType': json['levelType'] == null ? undefined : json['levelType'],
    };
}

export function SecurityLevelValueResponseToJSON(json: any): SecurityLevelValueResponse {
    return SecurityLevelValueResponseToJSONTyped(json, false);
}

export function SecurityLevelValueResponseToJSONTyped(value?: SecurityLevelValueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'levelValue': value['levelValue'],
        'levelType': value['levelType'],
    };
}

